import { getRgObjectsOfType as g, RG_TYPE as c } from "@project-rouge/rg-core";
import { mapRgObjectsByLevels as f } from "../../utils/rg-util/index6.js";
import { getPerimeter as o } from "./index8.js";
const d = (e, r, i) => {
  e = Array.isArray(e) ? e : [e];
  const l = g(e, c.Building);
  if (l.length <= 0)
    return 0;
  const m = Math.max(...l.flatMap((t) => t.data.levels.map((a) => a.levelIndex)));
  if (e = l, m <= r)
    return 0;
  const n = Array(m - r).fill(0).map((t, a) => r + 1 + a);
  let s;
  i ? s = f(e, n, i) : s = f(e, n, e.map((t) => t.type));
  let p = 0;
  for (const t of s.values())
    p += o(t);
  return p;
};
export {
  d as getAboveLevelPerimeter
};
//# sourceMappingURL=index2.js.map
